import logo from '@Components/Layout/Header/Assets/logo.svg'
import { CTAImage } from '@Features/LandingPage/Assets/Images'

export const defaultAssets = {
	logo,
	landing_main: CTAImage,
}
